<app-modal [info]="(info$ | async)!" (closeModal)="closeModal($event)"></app-modal>
